import React, { Fragment } from 'react'
import ReactMarkdown from 'react-markdown'

import Styled from './MarkdownText.styled'

const MarkdownText = ({ tagName, className, children, ...rest }) => {
  return (
    <Styled tagName={tagName} className={className} {...rest}>
      <ReactMarkdown
        disallowedElements={[tagName]}
        unwrapDisallowed
        components={{ p: Fragment }}
      >
        {children}
      </ReactMarkdown>
    </Styled>
  )
}
MarkdownText.defaultProps = {
  tagName: 'p',
}

export default MarkdownText
